// 引入qrcode
import QrCodeWithLogo from 'qrcode-with-logos';
export default {
  name: 'qrCode',
  props: {
    url: {
      type: String
    },
    imgSize: {
      type: [Number, String],
      Defaults: 130
    },
    logo: {
      type: String
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.newQrCode();
    });
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.newQrCode();
      });
    }
  },
  computed: {
    qrCodeDivStyles() {
      return {
        height: `${this.imgSize}px`,
        width: `${this.imgSize}px`
      };
    }
  },
  methods: {
    newQrCode() {
      let _this = this;
      if (this.url === '') return;
      new QrCodeWithLogo({
        image: this.$refs['qrCodeUrl'],
        content: this.url,
        width: Number(this.imgSize),
        nodeQrCodeOptions: {
          margin: 0
        },
        logo: {
          src: this.logo || require('@/assets/images/pc/icons/qrcode-logo.png')
        }
      }).toImage().then(result => {});
    }
  }
};